import FreeAiChatPage from '@/components/Pages/FreeAiChatPage';

export default FreeAiChatPage;
